import { makeAsyncActionCreators } from '../../helpers';
import { MeActionTypes } from '../types';

const loginUser = makeAsyncActionCreators(
  MeActionTypes.loginUser,
  ['email', 'password'],
  ['me'],
  ['error'],
);

const getMe = makeAsyncActionCreators(
  MeActionTypes.getMe,
  [],
  ['me'],
  ['error'],
);

const logoutUser = makeAsyncActionCreators(
  MeActionTypes.logoutUser,
  ['navigate', 'role'],
  [],
  ['error'],
);

const updateUserInteractions = makeAsyncActionCreators(
  MeActionTypes.updateUserInteractions,
  ['userId', 'interactionKey'],
  ['me'],
  ['error'],
);

export default {
  loginUser,
  getMe,
  logoutUser,
  updateUserInteractions,
};
